

(function ($) {

    window.CMG_Matchups = window.builder(CMG_Matchups, {
        subNavHighlight: function () {
            var url = window.location.pathname.toLowerCase();
            var found = false;
            $("nav.covers-CoversSubNav2 li a").each(function () {

                var menuUrl = $(this).attr('href');

                if (url.startsWith(menuUrl)) {
                    $(this).closest('li').addClass('covers-CoversSubNav-highlight');
                    found = true;
                    return false;
                }
                return true;
            });

            if (found === false && (url.includes("boxscore") || url.includes("matchup"))) {
                $("nav.covers-CoversSubNav2 li").eq(1).addClass('covers-CoversSubNav-highlight');
            }
        }
    });
})(jQuery);

//Odds table initialization function
function tableInit(){
    // odds tables
    var tableCont = $('.covers-CoversComponents-fixedTableContainer');

    $.each(tableCont, function (index, el) {
        var isDown = false;
        var startX;
        var scrollLeft;
        var game = $(el).children().first();
        // var box = $(el).find('div.box');
        var scCont = $(el).find('div.__scrollCont'); // Scrolling container for Odds tables
        var scrollCont = $(el).find('div.__scrollCont').children().first();
        var consensus = $(el).children().last();
        var table = $(scrollCont).children().first();
        var tableWidth = $(table).width();
        var scrollAreaWidth = $(scrollCont).width();

        if (tableWidth > scrollAreaWidth) {
            $(scCont).addClass('__right_boxshadow');
            $(table).css('cursor', 'grab');
        }

        $(scrollCont).scroll(function (event) {
            var containerWidth = this.scrollWidth - this.clientWidth;
            var position = this.scrollLeft;

            if (position == 0) {
                // $(game).removeClass('__boxshadow');
                $(scCont).removeClass('__left_boxshadow');
                $(scCont).addClass('__right_boxshadow');
            }

            if (position > 0) {
                // $(game).addClass('__boxshadow');
                $(scCont).addClass('__left_boxshadow');
                $(scCont).addClass('__right_boxshadow');
            }

            if (position < containerWidth) {
                // $(game).addClass('__boxshadow');
                $(scCont).addClass('__left_boxshadow');
                $(scCont).addClass('__right_boxshadow');
                if (position == 0) {
                    // $(game).removeClass('__boxshadow');
                    $(scCont).removeClass('__left_boxshadow');
                }
            }

            if (position == containerWidth) {
                // $(game).addClass('__boxshadow');
                $(scCont).addClass('__left_boxshadow');
                $(scCont).removeClass('__right_boxshadow');
            }
        });

        $(scrollCont).on({
            mousedown: function (event) {
                isDown = true;
                startX = event.pageX - this.offsetLeft;
                scrollLeft = this.scrollLeft;
            },
            mouseleave: function (event) {
                isDown = false;
            },
            mouseup: function (event) {
                isDown = false;
            },
            mousemove: function (event) {
                if (!isDown) return;
                event.preventDefault();
                var x = event.pageX - this.offsetLeft;
                var walk = (x - startX) * 3;
                this.scrollLeft = scrollLeft - walk;
            },
        });
    });

    // odds tables
    var newTableCont = $('.covers-odds-table');

    $.each(newTableCont, function (index, el) {
        var isDown = false;
        var startX;
        var scrollLeft;
        var table = el;
        var tableContainer = el.parentElement;
        var rightCell = $(".covers-CoversMatchups-LiveOddsPanel");
        var leftCell = $(".left-cell");

        if ($(table).width() > $(tableContainer).width()) {
            $(table).css('cursor', 'grab');
        }

        // $(leftCell).css("border-right", "1px solid #f6f6f6");

        $(tableContainer).scroll(function (event) {
            var containerWidth = this.scrollWidth - this.clientWidth;
            var position = this.scrollLeft;

            // right-cell-shadow
            // left-cell-shadow

            if (position == 0) {
                $(rightCell).removeClass('right-cell-shadow');
                $(leftCell).addClass('left-cell-shadow');
            }

            if (position > 0) {
                $(rightCell).addClass('right-cell-shadow');
                $(leftCell).addClass('left-cell-shadow');
            }

            if (position < containerWidth) {
                $(rightCell).addClass('right-cell-shadow');
                $(leftCell).addClass('left-cell-shadow');
                if (position == 0) {
                    $(leftCell).removeClass('left-cell-shadow');
                }
            }

            if (position == ($(table).width() - 200)) {
                $(leftCell).addClass('left-cell-shadow');
                $(rightCell).removeClass('right-cell-shadow');
            }

            if (position < containerWidth && position >= containerWidth - 20) {
                $(leftCell).addClass('left-cell-shadow');
                $(rightCell).removeClass('right-cell-shadow');
            }
        });

        $(tableContainer).on({
            mousedown: function (event) {
                isDown = true;
                startX = event.pageX - this.offsetLeft;
                scrollLeft = this.scrollLeft;
            },
            mouseleave: function (event) {
                isDown = false;
            },
            mouseup: function (event) {
                isDown = false;
            },
            mousemove: function (event) {
                if (!isDown) return;
                event.preventDefault();
                var x = event.pageX - this.offsetLeft;
                var walk = (x - startX) * 3;
                this.scrollLeft = scrollLeft - walk;
            },
        });
    });
}

document.addEventListener("DOMContentLoaded", (event) => {
    tableInit();
});


    // Book odds expander
    enableOddsExpander();
    function enableOddsExpander() {
        var CTAs = $(".odds-book-expander");
        $.each(CTAs, function (index, el) {
            $(el).click(function (event) {
                event.preventDefault();
                var expanded = $(this).attr('aria-expanded');

                if(expanded === 'false') {
                    $(this).attr('aria-expanded', 'true');
                }

                if(expanded === 'true') {
                    $(this).attr('aria-expanded', 'false');
                } 
            });
        });
    }
// responsive-tables.js
$(document).ready(function () {
    var switched = false;
    var updateTables = function () {
        if (($(window).width() < 767) && !switched) {
            switched = true;
            $("table.responsive").each(function (i, element) {
                splitTable($(element));
            });
            return true;
        }
        else if (switched && ($(window).width() > 767)) {
            switched = false;
            $("table.responsive").each(function (i, element) {
                unsplitTable($(element));
            });
        }
    };

    $(window).on('load',updateTables);
    $(window).on("redraw", function () { switched = false; updateTables(); }); // An event to listen for
    $(window).on("resize", updateTables);


    function splitTable(original) {
        original.wrap("<div class='table-wrapper' />");

        var copy = original.clone();
        copy.find("td:not(:first-child), th:not(:first-child)").css("display", "none");
        copy.removeClass("responsive");

        original.closest(".table-wrapper").append(copy);
        copy.wrap("<div class='pinned' />");
        original.wrap("<div class='scrollable' />");

        setCellHeights(original, copy);
    }

    function unsplitTable(original) {
        original.closest(".table-wrapper").find(".pinned").remove();
        original.unwrap();
        original.unwrap();
    }

    function setCellHeights(original, copy) {
        var tr = original.find('tr'),
            tr_copy = copy.find('tr'),
            heights = [];

        tr.each(function (index) {
            var self = $(this),
                tx = self.find('th, td');
            tx.each(function () {
                var height = $(this).outerHeight(true);
                heights[index] = heights[index] || 0;
                if (height > heights[index]) heights[index] = height;
            });

        });

        //tr_copy.each(function (index) {
        //$(this).height(heights[index]);
        //});

        tr_copy.each(function (index) {
            var self = $(this),
                tx = self.find('th, td');
            tx.each(function () {
                var height = $(this).outerHeight(true);
                heights[index] = heights[index] || 0;
                if (height > heights[index]) heights[index] = height;
            });
        });

        tr.each(function (index) {
            $(this).height(heights[index]);
        });
    }

});

$(window).on('load resize', function () {
    if ($(this).width() < 767) {
        $('table tfoot').hide();
    } else {
        $('table tfoot').show();
    }
});